import { render, staticRenderFns } from "./BulkSelectionBar.vue?vue&type=template&id=2bcd02d8"
import script from "./BulkSelectionBar.vue?vue&type=script&lang=js"
export * from "./BulkSelectionBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports